import { render } from "./bookingsComponent.vue?vue&type=template&id=16baf983&scoped=true"
import script from "./bookingsComponent.vue?vue&type=script&lang=js"
export * from "./bookingsComponent.vue?vue&type=script&lang=js"

import "./bookingsComponent.vue?vue&type=style&index=0&id=16baf983&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16baf983"]])

export default __exports__